import {
    EplLookupMethod,
    FetchState,
    ProductScannerState,
    UserFeedbackEventAction
} from "@/shared/types";
import * as UserService from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";
import { useUserFeedbackStore } from "@/employee/store/userFeedback";

export const SigisLicenseAgreementDocumentKey = "sigis-license-agreement";

export const initialState: ProductScannerState = {
    fetchState: FetchState.Uninitialized
};

export const useProductScannerStore = defineStore("productScanner", {
    state: () => (_.cloneDeep(initialState)),
    getters: {
        awaitingScan: state => state.fetchState === FetchState.Uninitialized,
        productScanning: state => state.fetchState === FetchState.Loading
    },
    actions: {
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },
        lookupItem (request: { productCode: string, method: EplLookupMethod }) {
            this.setFetchState(FetchState.Loading);

            return UserService.eplLookupItem(request.productCode, request.method)
                .then(response => {
                    this.setFetchState(FetchState.Loaded);
                    const userFeedbackStore = useUserFeedbackStore();
                    userFeedbackStore.setUserFeedbackAction(UserFeedbackEventAction.ProductScanner);
                    return response.data;
                })
                .catch(error => {
                    this.setFetchState(FetchState.Uninitialized);
                    return storeHelper.handleError({ error, rethrow: true });
                });
        },
        initializeState () {
            this.setFetchState(FetchState.Uninitialized);
        }
    }
});